import type { ReactNode } from 'react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';

/**
 * O rodapé de RASCUNHO do `TravelCalendar` (hotel e carro): o resumo do período
 * em cena e o `Confirmar`, que só acende com as duas pontas. Vai no `footer`
 * do calendário, que o põe no fluxo (popover) ou pregado embaixo (folha).
 *
 * `size="lg"` (36px, raio do DS) no popover, não a pílula `sm`: este Confirmar
 * e o do painel do aéreo confirmam a mesma coisa e liam em alturas diferentes
 * (28 contra 36) — chamada do designer, 2026-08-18. Na folha e no cartão
 * (`full`), largura cheia em pílula, e o resumo no 14/20 do rodapé da folha
 * (#5662).
 */
export function TravelCalendarConfirm({
  summary,
  confirmLabel,
  disabled,
  full,
  onConfirm,
}: {
  readonly summary: string;
  readonly confirmLabel: string;
  readonly disabled: boolean;
  /** Largura cheia: a folha estreita e o cartão de um mês. */
  readonly full: boolean;
  readonly onConfirm: () => void;
}): ReactNode {
  return (
    <>
      <p
        className={`${full ? 'text-sm' : 'text-xs'} font-medium text-muted-foreground`}
        aria-live="polite"
      >
        {summary}
      </p>
      <Button
        size={full ? 'xl' : 'lg'}
        className={full ? 'w-full rounded-full' : 'ml-auto'}
        disabled={disabled}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </>
  );
}
